<nav class="head-nav">
  <div class="nav-container">
    <div>
      <h2>{{ "servers.Servers Assignment" | translate }}</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]='["/admin"]'>{{ "general.Home" | translate }}</a>
        </li>
        <li class="breadcrumb-item" *ngIf="restaurantId">
          <a class="breadcrumb-restaurant-name" [routerLink]='["/admin/restaurants/profile", restaurantId]'>{{restaurantData?.name}}</a>
        </li>
        <li class="breadcrumb-item">{{"servers.Servers Assignment" | translate}}</li>
      </ol>
    </div>

    <app-restaurants-dropdown (all)="restaurantId = $event; GetScreenData()"></app-restaurants-dropdown>
  </div>
</nav>

<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>

<div class="form-page server-assignment" *ngIf='!dataLoading'>
  <div class="form-content">

    <div class="pb-2 mb-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div class="font-16 fontMedium">
          {{ 'servers.Select the method for assigning servers to tables.' | translate }}
        </div>
        <div *ngIf="details?.canAdd">
          <button mat-raised-button
            color="primary" (click)="save()"
            [disabled]="loading" [class.loading]="loading">
            {{"forms.Save" | translate}}
          </button>
        </div>
      </div>

      <mat-radio-group class="assign-type row" [(ngModel)]="assignType">
        <div class="col-6">
          <mat-radio-button [value]="'Manually'">
            <div class="font-20 fontMedium">{{ 'servers.Manually' | translate }}</div>
            <p>{{ 'servers.You will assign each server to the table(s) he or she is in charge of.' | translate }}</p>
          </mat-radio-button>
        </div>
        <div class="col-6">
          <mat-radio-button [value]="'Auto'">
            <div class="font-20 fontMedium">{{ 'servers.Auto Assignment' | translate }}</div>
            <p>{{ 'servers.BonTech App will assign the servers to the tables based on your chosen rotation rule.' | translate }}</p>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </div>

    <div class="card" [hidden]="assignType !== 'Auto'">
      <div class="card-header">
        <div class="title font-20 fontMedium">{{'servers.Auto Assignment Options' | translate}}</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <mat-form-field class="form-group" hideRequiredMarker>
              <mat-label>{{ 'servers.Set Rotation Rule' | translate }}</mat-label>
              <mat-select [formControl]="ruleCtr" [required]="assignType === 'Auto'">
                <mat-option *ngFor="let item of AutoAssignType" [value]="item">
                  {{('servers.' + item) | translate}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="ruleCtr.hasError('required')">{{ 'forms.Required' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </div>

        <p class="info" *ngIf="ruleCtr.value == 'LowestReservations'">{{'servers.Your selection means prioritize servers with the lowest number of tables assigned to him/her for that day' | translate}}</p>
        <p class="info" *ngIf="ruleCtr.value == 'LastSeatedTime'">{{'servers.Your selection means prioritize your servers with the longest duration since the last seated reservation' | translate}}</p>
        <p class="info" *ngIf="ruleCtr.value == 'LowestPartySize'">{{'servers.Your selection means prioritize your servers with the lowest number of guests at the current time' | translate}}</p>
      </div>
    </div>

    <div class="card" [hidden]="assignType !== 'Manually'">
      <div class="card-header">
        <div class="title font-20 fontMedium">{{'servers.Assign Servers to Table' | translate}}</div>
        <p class="info"
          [ngClass]="{'red-color': !floors.length && isSubmitted}"
          >{{ 'servers.Choose a table to assign servers to.' | translate }}</p>
      </div>
      <div class="card-body">
        <div class="floor-view">

          <div *ngIf="floors?.length">
            <app-all-floors-viewer
              [floors]="floors"
              [isView]="true"
              [tablesToSelect]="tablesToSelect"
              (selectedFloor)="selectedFloor = $event"
              (selectedTables)="selectedTable = $event[0]; openForm()">
            </app-all-floors-viewer>
          </div>

          <ng-container *ngIf='!floors?.length'>
            <empty-state [title]='"general.No Data Found" | translate'></empty-state>
          </ng-container>
        </div>
      </div>
    </div>

  </div>
</div>
